const DATA = {
  title: 'Privacy Policy for Lazy Labs Inc',
  texts: [
    { text: 'Effective Date: 21st February 2025' },
    {
      text: 'At Lazy Labs Inc ("Lazy Labs Inc," "Lazy," "we," "us," "our") respects your privacy and is committed to safeguarding your Personal Information. This Privacy Policy describes the types of Personal Information we collect, how we use and share it, and the choices and rights you may have regarding your information. This Privacy Policy applies to the use of our website at',
      href: 'https://lazy.so',
      hrefText: ' https://lazy.so ',
      endText: '(the “Site”) and our related applications, products, and services (collectively, the “Services”).',
    },
    { text: '1. Information We Collect', tag: 'h3' },
    {
      text: 'We collect information to provide, improve, and personalize our Services. Here’s an overview of what we collect:',
    },
    { text: '1.1 Information You Provide Directly', tag: 'h4' },
    {
      text: 'Account Information: When you register for an account, we collect information such as your name, email address, and any other details you choose to provide.',
      tag: 'li',
    },
    {
      text: 'User Content: You retain ownership of all notes, tasks, ideas, and other content you upload or input into the Services (“User Content”).',
      tag: 'li',
    },
    {
      text: 'Payment Information: For subscriptions and transactions, we collect billing details including your payment information and billing address. Payments are processed securely by Stripe in accordance with their',
      href: 'https://stripe.com/fr/legal/ssa',
      hrefText: ' terms of service.',
      tag: 'li',
    },
    { text: '1.2 Information We Collect Automatically', tag: 'h4' },
    {
      text: 'Usage Data: We automatically collect information about your interactions with the Services, such as pages viewed, features used, and time spent on each page.',
      tag: 'li',
    },
    {
      text: 'Device Data: We collect information about the devices you use to access the Services, including your IP address, browser type, and operating system.',
      tag: 'li',
    },
    { text: '1.3 Information From Third Parties', tag: 'h4' },
    {
      text: 'Authentication via Google: If you choose to authenticate through Google, we collect your name, email address, and a unique identifier associated with your Google account. This information helps verify your identity and secure your access to the Services.',
      tag: 'li',
    },
    { text: '2. Cookies and Tracking Technologies', tag: 'h3' },
    {
      text: 'Lazy Labs Inc utilizes cookies and similar tracking technologies to enhance the functionality of the Services and analyze user interactions. Cookies are small text files stored on your device that enable us to recognize you, remember your preferences, and enhance your user experience. We use cookies for:',
    },
    { text: 'Authentication and Security: To verify your identity and secure your account.', tag: 'li' },
    {
      text: 'Performance and Analytics: To understand how users interact with the Services and improve their functionality.',
      tag: 'li',
    },
    { text: 'Preferences: To store user preferences, such as language settings.', tag: 'li' },
    {
      text: 'Marketing and Advertising: To deliver personalized content and measure the effectiveness of our marketing campaigns.',
      tag: 'li',
    },
    {
      text: 'Some of these cookies are placed by third-party providers, such as Mixpanel and Google Analytics, which help us with analytics and performance tracking.',
    },
    { text: '3. How We Use Your Information', tag: 'h3' },
    {
      text: 'We use the Personal Information and User Data we collect in accordance with this Privacy Policy. We do not sell or rent your Personal Information or User Data to any third party.',
    },
    { text: '' },
    { text: 'We may use your Personal Information to:' },
    {
      text: 'Operate, improve, and personalize the Service: To enhance features, functionality, and overall user experience.',
      tag: 'li',
    },
    {
      text: 'Billing Identification and Authentication: To process payments securely, verify user identities, and help prevent fraud.',
      tag: 'li',
    },
    {
      text: 'Communications: To send account-related updates, security alerts, and other administrative messages. You may opt out of receiving promotional communications at any time.',
      tag: 'li',
    },
    {
      text: 'Marketing Materials: With your explicit consent, to provide you with information regarding new features, services, or promotions.',
      tag: 'li',
    },
    {
      text: 'Analytics: To understand how users interact with the Services, improve usability, and enhance performance. Where possible, we use aggregated or pseudonymized data for analytics.',
      tag: 'li',
    },
    {
      text: 'Troubleshooting: To identify, diagnose, and resolve technical issues and optimize the stability and performance of the Services.',
      tag: 'li',
    },
    {
      text: 'Compliance: To enforce our terms, comply with applicable legal obligations, and address fraudulent or unlawful activities.',
      tag: 'li',
    },
    { text: '4. Sharing Your Information', tag: 'h3' },
    {
      text: 'We do not sell your Personal Information. We may, however, share certain Personal Information with trusted third-party service providers (subprocessors) who assist us in delivering and improving the Services. These service providers include, but are not limited to:',
    },
    { text: 'Stripe: Payment processing.', tag: 'li' },
    { text: 'Google: Authentication, account management and analytics.', tag: 'li' },
    { text: 'Heroku: Hosting infrastructure.', tag: 'li' },
    { text: 'AWS: Cloud storage and computing.', tag: 'li' },
    { text: 'Mixpanel: Usage analytics.', tag: 'li' },
    { text: 'Hubspot: Customer relationship management.', tag: 'li' },
    { text: 'Zapier: Automation workflows.', tag: 'li' },
    { endText: ': Data integration.', tag: 'li', href: 'https://segment.io', hrefText: 'Segment.io' },
    { endText: ': Communication and email delivery.', tag: 'li', href: 'https://customer.io', hrefText: 'Customer.io' },
    { text: 'OpenAI: Providing intelligent features.', tag: 'li' },
    { text: 'Crashlytics: Error and crash reporting.', tag: 'li' },
    { text: 'Typeform: Collecting user feedback and survey responses.', tag: 'li' },
    { text: '4.1 Data Protection with Subprocessors', tag: 'h4' },
    {
      text: 'All subprocessors are contractually required to handle Personal Information securely and in accordance with applicable laws. They must implement appropriate technical and organizational measures to protect the confidentiality, integrity, and availability of Personal Information.',
    },
    { text: '4.2 Employee Access to Data', tag: 'h4' },
    {
      text: 'Access to Personal Information by Lazy Labs Inc employees is strictly limited and may occur only under the following circumstances:',
    },
    {
      text: 'With Explicit User Consent: For the purpose of providing support or resolving technical issues upon your request.',
      tag: 'li',
    },
    { text: 'Legal Obligations: To comply with applicable laws, regulations, or valid legal processes.' },
    {
      text: 'Service Improvement: On a limited basis, to improve features, functionality, or performance, and always subject to strict confidentiality obligations.',
      tag: 'li',
    },
    {
      text: 'Business Transactions: In the event of a merger, acquisition, or sale of all or a portion of our assets, subject to applicable confidentiality and data protection obligations.',
      tag: 'li',
    },
    { text: '4.3 Cross-Border Data Transfers', tag: 'h4' },
    {
      text: 'Where Personal Information is transferred outside the European Economic Area (EEA), we rely on Standard Contractual Clauses (SCCs) approved by the European Commission and',
      href: 'https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj',
      hrefText: ' published ',
      endText:
        'on 7 June 2021 or other legally recognized transfer mechanisms to ensure that your Personal Information receives an adequate level of protection. We remain committed to complying with all applicable data protection requirements when transferring data across international borders.',
      tag: 'a',
    },
    { text: '5. Data Retention', tag: 'h3' },
    {
      text: 'We retain Personal Information for as long as necessary to provide the Services, fulfill the purposes outlined in this Privacy Policy, or as required by law. If you submit a deletion request pursuant to the General Data Protection Regulation (GDPR) or other applicable data protection laws, we will delete your Personal Information from active systems in a timely manner. Please note that certain information may remain in backup storage for a limited retention period, solely for disaster recovery and compliance purposes, after which it will be permanently deleted. We continually refine our data deletion processes to ensure compliance with all applicable legal requirements.',
    },
    { text: '6. Security Measures', tag: 'h3' },
    {
      text: 'We use industry-standard measures to protect your information. However, no system is entirely secure. Please note that data within the Service is not encrypted at rest or in transit. While we employ compensating controls to prevent unauthorized access, users should be aware that their data may be vulnerable to interception or unauthorized access during storage or transmission.',
    },
    { text: '7. Compliance with Data Protection Regulations', tag: 'h3' },
    {
      text: 'We comply with applicable data protection laws, including the GDPR and the California Consumer Privacy Act (CCPA), to the extent they apply. Subject to these laws, you may have the right to:',
    },
    { text: 'Access: Request a copy of the Personal Information we hold about you.', tag: 'li' },
    { text: 'Correction: Request that we correct inaccurate or incomplete information.', tag: 'li' },
    {
      text: 'Deletion: Request that we delete your Personal Information, subject to any legal obligations that may require us to retain it.',
      tag: 'li',
    },
    {
      text: 'Data Portability: Request your Personal Information in a machine-readable format for transfer to another service provider.',
      tag: 'li',
    },
    {
      text: 'Opt-Out of Sale: If applicable under the CCPA, request to opt out of any practices that may constitute a “sale” of Personal Information.',
      tag: 'li',
    },
    {
      text: 'To exercise any of these rights, please contact us at',
      href: 'mailto:care@lazy.so?subject=Hey from lazy.so',
      hrefText: ' care@lazy.so',
      endText:
        ' with the subject line “Data Request.” We will respond within the timeframes required by applicable law.',
      tag: 'a',
    },
    { text: '8. Children’s Privacy', tag: 'h3' },
    {
      text: 'Our Services are not intended for use by individuals under the age of 13. We do not knowingly collect Personal Information from children under 13. If we become aware that we have inadvertently collected such information, we will promptly take steps to delete it.',
    },
    { text: '9. Updates to This Policy', tag: 'h3' },
    {
      text: 'Lazy Labs Inc reserves the right to update this Privacy Policy to reflect changes in legal, operational, or technological requirements. Significant changes will be communicated through email or within the Services prior to their effective date. Your continued use of the Services following the effective date of any updated Privacy Policy constitutes your acceptance of those changes.',
    },
    { text: '10. Contact Us', tag: 'h3' },
    {
      text: 'For any inquiries or concerns regarding this Privacy Policy or our data practices, please contact us at:',
    },
    { text: 'Lazy Labs Inc' },
    { text: 'Email: ', href: 'mailto:care@lazy.so?subject=Hey from lazy.so', hrefText: 'care@lazy.so' },
    { text: 'Website: ', href: 'https://lazy.so', hrefText: 'https://lazy.so' },
  ],
}

export default DATA
